
import {get} from "@insite/client-framework/Services/ApiService";

export function getMyTemplateURL(date:string): Promise<string> {
        const url = get<string>(`api/v1/mytemplate?date=${ date}`);
        return url;
}

